import { Button, FoodsIcon } from "@foodpilot/foods";
import { Stack, useTheme, useMediaQuery, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link, Outlet, useParams } from "react-router";
import { useActionsContext } from "src/context/Actions/useActionsContext";
import { ActionPlanUpsertModal } from "../../ActionPlanUpsertModal/ActionPlanUpsertModal";
import { Fragment } from "react/jsx-runtime";
import { TabHeader } from "../TabHeader";

export const ActionPlanLayout = () => {
    const theme = useTheme();
    const { actionPlanActionId } = useParams();

    return (
        <Stack
            gap={theme.spacing(2)}
            width={"100%"}
            sx={{
                [theme.breakpoints.down("md")]: {
                    gap: 0,
                },
            }}
        >
            {actionPlanActionId === undefined && <MyActionPlanHeader />}
            <Stack>
                <Outlet />
            </Stack>
        </Stack>
    );
};

const MyActionPlanHeader = () => {
    const theme = useTheme();
    const { t } = useTranslation();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    const { urls } = useActionsContext();

    const url = urls.catalog();
    return (
        <Box
            sx={{
                display: "grid",
                gridTemplateColumns: { xs: "minmax(0, 1fr)", md: "minmax(0, 1fr) auto" },
                gridTemplateAreas: { xs: '"title" "add" "edit"', md: '"title ." "edit add"' },
                columnGap: 2,
                rowGap: { xs: 2, md: 1 },
                pb: { xs: 2, md: 0 },
                alignItems: "center",
                minWidth: 0,
            }}
        >
            <Box sx={{ gridArea: "title", minWidth: 0, overflowWrap: "anywhere" }}>
                <TabHeader title={t("actionplan.title", "My action plan")} showOnMobile />
            </Box>
            <Box sx={{ gridArea: "add", minWidth: 0 }}>
                <Link to={url}>
                    <Button
                        variant="primary"
                        startIcon={<FoodsIcon size={2} icon="plus" />}
                        sx={{ width: { xs: "100%", md: "auto" }, whiteSpace: "normal" }}
                    >
                        {isMobile ? t("glossary.add", "Add") : t("actions.add_actions", "Add actions")}
                    </Button>
                </Link>
            </Box>
            <ActionPlanConfigurationButton />
        </Box>
    );
};

const ActionPlanConfigurationButton = () => {
    const theme = useTheme();
    const { t } = useTranslation();
    const { isOpenActionPlanForm, setOpenActionPlanForm } = useActionsContext();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    const handleEditTrajectories = () => {
        setOpenActionPlanForm(true);
    };

    return (
        <Fragment>
            {isOpenActionPlanForm && <ActionPlanUpsertModal />}
            <Box sx={{ gridArea: "edit", minWidth: 0 }}>
                <Button
                    variant={isMobile ? "secondary" : "ternary"}
                    startIcon={<FoodsIcon size={2} icon="edit" />}
                    onClick={handleEditTrajectories}
                    sx={{ width: { xs: "100%", md: "auto" }, whiteSpace: "normal" }}
                >
                    {isMobile ? t("common.actions.edit", "Edit") : t("actions.edit_parameters", "Edit parameters")}
                </Button>
            </Box>
        </Fragment>
    );
};
